import {
  P2GTableContainer,
  P2GPaper,
  P2GTable,
  P2GTableHead,
  P2GTableRow,
  P2GTableCell,
  P2GTableBody
} from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { Product, ProductSlots } from '../adapters/product-types';
import { ProductTableRow } from './product-table-row';

type ProductTableViewProps = {
  product: Product;
  slots?: ProductSlots;
};

export function ProductTableView({ product, slots }: ProductTableViewProps) {
  const { t } = useTranslation(TranslationNamespaces.CHECKOUT);
  return (
    <P2GTableContainer id="table-container" component={P2GPaper} dataTestId="table-order-summary">
      <P2GTable size="medium">
        <P2GTableHead>
          <P2GTableRow>
            <P2GTableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
              {t('TABLE_ORDER_SUMMARY_ID', { defaultValue: '#' })}
            </P2GTableCell>
            <P2GTableCell>{t('TABLE_ORDER_SUMMARY_DELIVERING_TO', { defaultValue: 'Delivering To' })}</P2GTableCell>
            <P2GTableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
              {t('TABLE_ORDER_SUMMARY_ITEMS', { defaultValue: 'Items' })}
            </P2GTableCell>
            <P2GTableCell>
              {t('TABLE_ORDER_SUMMARY_COURIER_SERVICE', { defaultValue: 'Courier & Service' })}
            </P2GTableCell>
            <P2GTableCell>{t('TABLE_ORDER_SUMMARY_PRICE', { defaultValue: 'Price' })}</P2GTableCell>
            <P2GTableCell />
          </P2GTableRow>
        </P2GTableHead>
        <P2GTableBody>
          {product.items.map((item, index) => (
            <ProductTableRow key={item.id} item={item} currency={product.currency} slots={slots} index={index} />
          ))}
        </P2GTableBody>
      </P2GTable>
    </P2GTableContainer>
  );
}
